<template>
  <svg data-icon-name="callback" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.219 49.5" fill="none" stroke="#231f20" stroke-linejoin="round" stroke-width="1.5"><path d="M32.605 30.469a1.04 1.04 0 0 0-1.449-.026l-3.165 3.085a.62.62 0 0 1-.163.118c-3.085 1.563-14.224-10.363-12.1-12.6l3.175-3.111a1.04 1.04 0 0 0 .014-1.471L8.526 5.864c-.193-.197-.456-.309-.732-.311s-.541.105-.737.299c-5.2 5.108-13.546 10.244 5.942 30.121 19.233 19.614 24.746 12.181 30.055 6.472a1.04 1.04 0 0 0-.019-1.44z"/><path d="M41.243 22.776A14.38 14.38 0 0 0 26.364 7.895M48.463 22.8a21.58 21.58 0 0 0-6.315-15.779C37.973 2.846 32.272.564 26.37.705m-.007 14.444a7.2 7.2 0 0 1 5.577 2.09 7.19 7.19 0 0 1 2.09 5.577" stroke-linecap="round"/></svg>
</template>

<script>
import {
  defineComponent,
} from 'vue';

export default defineComponent({});
</script>
